import { useState } from "react"

import { Dialog } from "~/ui-rtk/components/ui/common"
import { CloseSvg } from "~/ui-rtk/components/ui/svg/essentials"
import { H2 } from "~/ui-rtk/components/ui/typography"
import {
  SOS_BOOK_A_CALL_URL,
  SOS_UPSELL_BODY,
  SOS_UPSELL_HEADLINE,
} from "~/ui-rtk/constants/sos"
import useAccess from "~/ui-rtk/hooks/access"

/**
 * Recurring upsell modal on the SoS report (APP-486): the paywall hero plus
 * the booking CTA, shown once per visit to free companies — recurrence per
 * visit is the spec, so dismissal is deliberately not persisted. Closes via
 * X, Escape, or backdrop; the report stays fully usable afterwards.
 */
export default function SosUpsellModal() {
  const { isSosFree } = useAccess()
  const [isOpen, setIsOpen] = useState(true)

  if (!isSosFree) {
    return null
  }

  const handleClose = () => setIsOpen(false)

  return (
    <Dialog
      isOpen={isOpen}
      handleClose={handleClose}
      width={440}
      closeOnClickOutside
    >
      <div className="relative rounded-md py-8 px-8 bg-basic-dark-blue shadow-deep border border-basic-blue text-center flex flex-col items-center gap-4">
        {/* First in DOM order + data-autofocus so keyboard users land on the
            dismiss control, not the external CTA. */}
        <button
          aria-label="Close"
          data-autofocus
          className="absolute right-4 top-4 max-w-7 max-h-7 p-2 flex items-center justify-center hover:bg-[#2a2c33] hover:text-white transition-colors rounded-1"
          onClick={handleClose}
        >
          <CloseSvg size={20} fill="platinum" />
        </button>
        <H2>{SOS_UPSELL_HEADLINE}</H2>
        <p className="opacity-70">{SOS_UPSELL_BODY}</p>
        <a
          href={SOS_BOOK_A_CALL_URL}
          target="_blank"
          rel="noreferrer"
          className="btn btn-primary btn-wide mt-2"
        >
          Pick a time
        </a>
      </div>
    </Dialog>
  )
}
